export const nationalityMapper = ({ id, demonym: label, country }) => ({
  id,
  label,
  value: id,
  country,
})
